import {Component, OnInit} from '@angular/core'
import {faFileInvoice} from '@fortawesome/pro-solid-svg-icons/faFileInvoice'
import {faReceipt} from '@fortawesome/pro-solid-svg-icons/faReceipt'
import {faUserClock} from '@fortawesome/pro-solid-svg-icons/faUserClock'
import {OptableLayout} from '../../../../core/components/layout/optable-layout.interface'
import {ActivatedRoute} from '@angular/router'
import {JobRequestRepository} from '../job-request.repository'
import {PageComponent, PageMetadata} from '../../../../core/seo/page-metadata'
import {Observable} from 'rxjs'
import {TranslocoService} from '@ngneat/transloco'
import {map} from 'rxjs/operators'

@Component({
  templateUrl: './job-request-success-page.component.html',
  standalone: false,
})
export class JobRequestSuccessPageComponent extends PageComponent implements OnInit, OptableLayout {
  readonly iconStep1 = faUserClock
  readonly iconStep2 = faFileInvoice
  readonly iconStep3 = faReceipt
  optOutOfLayout = true
  jobNumber?: string

  constructor(
    private readonly repository: JobRequestRepository,
    private readonly route: ActivatedRoute,
    private readonly translationService: TranslocoService,
  ) {
    super()
  }

  getPageMetadata(): Observable<PageMetadata> {
    return this.translationService.selectTranslate('createJobRequest.submitted.pageTitle').pipe(map(title => ({title})))
  }

  ngOnInit(): void {
    const jobNumber = (this.jobNumber = this.route.snapshot.params['id'])
    this.repository.setRecentJobNumber(jobNumber)
    this.repository.clearJobRequestState()
  }
}
